import { ColumnsType } from 'antd/lib/table'
import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import DownloadShipmentBlank from '../../../../components/buttons/download-shipment-blank/download-shipment-blank'
import { ManagerShipmentRow } from '../helpers/calc-manager-monthly-stats'

export const columns: ColumnsType<ManagerShipmentRow> = [
    {
        dataIndex: 'shipmentId',
        title: 'Номер отгрузки',
        width: 100,
    },
    {
        dataIndex: 'clientName',
        title: 'Клиент',
    },
    {
        dataIndex: 'createdAt',
        title: 'Дата',
        width: 160,
        render: (_, record) => renderDatetime(record.createdAt),
    },
    {
        dataIndex: 'percent',
        title: 'Процент, %',
        width: 80,
        align: 'right',
        render: (_, record) => `${record.percent}%`,
    },
    {
        dataIndex: 'commission',
        title: 'Баллы',
        width: 110,
        align: 'right',
        render: (_, record) => formatIntegerBySpace(Math.round(record.commission)),
    },
    {
        dataIndex: 'manager',
        title: 'Создал',
        width: 110,
        align: 'right',
        render: (_, record) => record.manager ?? '—',
    },
    {
        key: 'actions',
        title: 'Бланк',
        width: 60,
        align: 'center',
        render: (_, record) => (
            <DownloadShipmentBlank
                shipment={{ documentId: record.documentId, id: record.id }}
                blankType='client'
                blankPreviewFiles={record.blankPreviewFiles}
            />
        ),
    },
]
